export function useFacebookPixel() {
  const { $fbq } = useNuxtApp();
  const PIXEL_ID = '1406551917009653';

  const initPixel = (): void => {
    if (import.meta.client) {
      ($fbq as any)?.('init', PIXEL_ID);
    }
  };

  const fbqTrack = (event: string): void => {
    if (import.meta.client) {
      ($fbq as any)?.('trackSingleCustom', PIXEL_ID, event);
    }
  };

  const fbqCustomTrack = (event: string): void => {
    if (import.meta.client) {
      ($fbq as any)?.('trackSingleCustom', PIXEL_ID, event);
    }
  };

  return {
    fbqTrack,
    initPixel,
    fbqCustomTrack,
    pixelId: PIXEL_ID,
  };
}
